import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol viewBox=\"0 0 11 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.5 5.70264H0V3.70264H9.5V5.70264Z\" fill=\"currentColor\" />\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.58002 4.70267L5.78002 1.90267L7.19002 0.482666L10.69 3.97267C11.08 4.36267 11.08 4.99267 10.69 5.38267L7.19002 8.88267L5.77002 7.46267L8.56002 4.66267L8.58002 4.70267Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol